<app-button (click)="copyJSON()">Copy JSON</app-button>
<div class="data" *ngIf="data">
	<ngx-json-viewer [json]="data"></ngx-json-viewer>
</div>
